import { create } from "zustand";

function convertJsonFormat(frontendJson) {
  const backendJson = {};

  for (const key in frontendJson) {
    if (frontendJson.hasOwnProperty(key)) {
      if (key.includes("-comments")) {
        const newKey = key.replace("aq", "comment_q").replace("-comments", "");
        backendJson[newKey] = frontendJson[key];
      } else {
        backendJson[key] = frontendJson[key];
      }
    }
  }

  return backendJson;
}

const convertJsonToUrlEncoded = (json) => {
  const urlSearchParams = new URLSearchParams();

  for (const key in json) {
    if (json.hasOwnProperty(key)) {
      urlSearchParams.append(key, json[key]);
    }
  }

  return urlSearchParams.toString();
};

const useFeedbackStore = create((set, get) => ({
  feedback: {},
  setFeedback: (questionId, value) =>
    set((state) => ({
      feedback: { ...state.feedback, [questionId]: value },
    })),
  submitFeedback: async () => {
    try {
      let feedback_obj = convertJsonFormat(get().feedback);

      const formData = convertJsonToUrlEncoded(feedback_obj);

      const response = await fetch("https://rawdat.ai/login/portal/feedback", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      });

      if (response.ok) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error in feedback data", error);
    }
  },
  clearFeedback: () => set({ feedback: {} }),
}));

export default useFeedbackStore;
